import { render, staticRenderFns } from "./CaseManageView.vue?vue&type=template&id=abe0b504&scoped=true"
import script from "./CaseManageView.vue?vue&type=script&lang=js"
export * from "./CaseManageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe0b504",
  null
  
)

export default component.exports